export const APPLICATION_MODE = {
  OPENED: 'OPENED',
  CLOSED: 'CLOSED',
  OPENING: 'OPENING',
  CLOSING: 'CLOSING',
};



// WEBPACK FOOTER //
// ./src/app/constants/trailer.js